import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getStatusColor, getPriorityColor, formatDate, truncateText } from '../../utils/helpers';
import './TicketList.css';

export default function TicketList({ tickets, loading, onStatusFilter }) {
  const navigate = useNavigate();

  if (loading) {
    return <div className="loading-state">Loading tickets...</div>;
  }

  if (!tickets || tickets.length === 0) {
    return (
      <div className="empty-state">
        <span className="empty-icon">📭</span>
        <h3>No Tickets Found</h3>
        <p>There are no tickets to display at the moment.</p>
      </div>
    );
  }

  return (
    <div className="ticket-list">
      <div className="ticket-list-header">
        <h2>Tickets ({tickets.length})</h2>
        <div className="filter-buttons">
          <button onClick={() => onStatusFilter(null)} className="filter-btn">All</button>
          <button onClick={() => onStatusFilter('Open')} className="filter-btn">Open</button>
          <button onClick={() => onStatusFilter('In Progress')} className="filter-btn">In Progress</button>
          <button onClick={() => onStatusFilter('Closed')} className="filter-btn">Closed</button>
        </div>
      </div>

      <div className="tickets-grid">
        {tickets.map((ticket) => (
          <div
  key={ticket.id}
  className="ticket-card"
  onClick={() => navigate(`/ticket/${ticket.id}`)}  // ✅ Correct path
>

            <div className="ticket-card-header">
              <span className="ticket-number">{ticket.ticket_number}</span>
              <span
                className="ticket-status"
                style={{ backgroundColor: getStatusColor(ticket.status) }}
              >
                {ticket.status}
              </span>
            </div>

            <div className="ticket-card-body">
              <h3 className="ticket-query">{truncateText(ticket.query, 60)}</h3>
              <div className="ticket-meta">
                <span className="ticket-category">📁 {ticket.category}</span>
                <span
                  className="ticket-priority"
                  style={{ color: getPriorityColor(ticket.priority) }}
                >
                  {ticket.priority}
                </span>
              </div>
            </div>

            <div className="ticket-card-footer">
              <span className="ticket-date">🕒 {formatDate(ticket.created_at)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
